import store from '../store';
import HomeLayout from '../layouts/HomeLayout';
import InternalLayout from '../layouts/InternalLayout';
import Home from '../pages/Home/Index';
import QuoteSign from '../pages/QuoteSign/QuoteSign';
import QuoteSignMLA from '../pages/QuoteSign/QuoteSignMLA';
import Error from '../pages/Error/Error';
import OrderVerification from '../pages/OrderVerification/OrderVerification';
import BusinessDetailsIndex from '../pages/BusinessDetails/Index';
import ApprovalsIndex from '../pages/Approvals/Index';
import ApplicationWaiting from '../pages/Approvals/ApplicationWaiting';
import ApplicationOnHold from '../pages/Approvals/ApplicationOnHold';
import WetSignSecondary from '../pages/Approvals/WetSignSecondary';
import ReviewAndSignContractIndex from '../pages/ReviewAndSignContract/Index';
import ResetPassword from '../pages/Auth/ResetPassword';
import { onLogout } from '../vue-apollo';
import CalculatorRoutes from './calculator-routes';
import CalculatorAuthRoutes from './calculator-auth-routes';
// for testing purpose
import IDScanIndex from '../pages/IDScan/Index';
import { LoginRedirect, LogoutRedirect } from 'eclipx.ui';

export default [
  // Un Authenticated Routes
  {
    path: '/login',
    name: 'login',
    component: LoginRedirect,
    meta: { skipAuthentication: true },
    props: function (route) {
      const showLoginQuery = route.query.showLogin;
      const showLoginCondition = typeof showLoginQuery === 'string' && showLoginQuery === 'false';

      return {
        redirectLoginOptions: {
          ...(showLoginCondition && { showLogin: showLoginQuery }),
          fragment: `domainkey=${encodeURIComponent(window.location.hostname)}`
        }
      };
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutRedirect,
    meta: { skipAuthentication: true },
    beforeEnter: (to, from, next) => {
      // Clear the  local user when logging out
      store.commit('auth/clearUser');
      store.commit('vehicleApplication/clearVehicleApplication');
      next((vm) => {
        onLogout(vm.$apollo);
      });
    }
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    meta: { skipAuthentication: true },
    props: {
      redirectUri: '/',
      name: 'home'
    }
  },
  {
    path: '/',
    name: 'home',
    meta: { layout: InternalLayout },
    component: Home
  },
  {
    path: '/applications/:applicationId',
    name: 'applications',
    meta: { layout: InternalLayout },
    component: Home,
    children: [
      {
        path: 'quotesign',
        name: 'quotesign',
        meta: { skipAuthentication: true },
        component: QuoteSign
      },
      {
        path: 'quotesign-mla',
        name: 'quotesign-mla',
        meta: { skipAuthentication: true },
        component: QuoteSignMLA
      },
      {
        path: 'orderVerification',
        name: 'orderVerification',
        meta: { layout: InternalLayout },
        component: OrderVerification
      },
      {
        path: 'businessDetails',
        name: 'businessDetails',
        meta: { layout: InternalLayout },
        component: BusinessDetailsIndex
      },
      {
        path: 'approvals',
        name: 'approvals',
        meta: { layout: InternalLayout },
        component: ApprovalsIndex
        // beforeEnter: PrimaryOrSecondaryGuard
      },
      {
        path: 'approvals-waiting',
        name: 'approvals-waiting',
        meta: { layout: InternalLayout },
        component: ApplicationWaiting
        // beforeEnter: PrimaryOrSecondaryGuard
      },
      {
        path: 'application-on-hold',
        name: 'application-on-hold',
        meta: { layout: InternalLayout },
        component: ApplicationOnHold
        // beforeEnter: PrimaryOrSecondaryGuard
      },
      {
        path: 'secondary-waiting',
        name: 'wet-signature-secondary',
        meta: { layout: InternalLayout },
        component: WetSignSecondary
      },
      {
        path: 'reviewAndSignContract',
        name: 'reviewAndSignContract',
        meta: { layout: InternalLayout },
        component: ReviewAndSignContractIndex
        // beforeEnter: PrimaryOrSecondaryGuard
      },
      {
        path: 'id-scan',
        name: 'id-scan',
        meta: { layout: InternalLayout },
        component: IDScanIndex
      }
    ]
  },
  {
    path: '/error',
    name: 'error',
    meta: { layout: HomeLayout, skipAuthentication: true },
    component: Error,
    props: true
  },
  ...CalculatorRoutes,
  ...CalculatorAuthRoutes
];
